import { env } from "@monta/env";
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from "@apollo/client";

export default function createStrapi() {
  const httpLink = new HttpLink({ uri: `${env.STRAPI_URL}/graphql` });

  const uploadsMiddleware = new ApolloLink((operation, forward) => {
    return forward(operation).map((res) => {
      res.data = JSON.parse(
        JSON.stringify(res.data).replace(
          /"\/uploads\//g,
          `"${env.STRAPI_URL}/uploads/`,
        ),
      );

      return res;
    });
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: uploadsMiddleware.concat(httpLink),
  });

  return client;
}
